import { Navigate, useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/apiClient';
import { PepiteLoader } from '@/components/ui/PepiteLoader';

interface ProtectedRouteProps {
    children: React.ReactNode;
    adminOnly?: boolean;
    allowedEmails?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, adminOnly = false, allowedEmails }) => {
    const location = useLocation();

    // Security fix: auth is now via httpOnly cookies (not localStorage token)
    // Always attempt to call /me — cookies are sent automatically via withCredentials
    const { data: user, isLoading, isError } = useQuery({
        queryKey: ['user'],
        queryFn: () => apiClient.auth.me(),
        retry: false,
        staleTime: 1000 * 60 * 5, // 5 minutes
    });

    if (isLoading) {
        return (
            <div className="h-screen flex items-center justify-center bg-gray-50">
                <div className="flex flex-col items-center gap-4">
                    <PepiteLoader className="w-16 h-16" />
                    <p className="text-gray-500 font-medium">Vérification des accès...</p>
                </div>
            </div>
        );
    }

    if (isError || !user || !user.id) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (adminOnly) {
        if (allowedEmails && user.email && allowedEmails.includes(user.email)) {
            // Allow access even if not admin
        } else if (!user.is_admin) {
            return <Navigate to="/swipe" replace />;
        }
    }

    return <>{children}</>;
};

export default ProtectedRoute;
